import { MeldungBewilligungFilter } from "@app/shared/classes/meldung-bewilligung-filter";

export class MeldungFilter {
  sortColumn    : string = '';
  sortOrder     : string = '';

  freitext      : string = '';
  land          : number = 0;
  status        : number = 0;
  offeneAnfrage : number = 0;
  datumVon      : string = '';
  datumBis      : string = '';

  limit         : number = 0;
  page          : number = 0;

  blvStatus     : number = 0;
  bewilligung   : MeldungBewilligungFilter = new MeldungBewilligungFilter();

  public constructor(init?: Partial<MeldungFilter>) {
    Object.assign(this, init);
  }

  static fromJSON(json: string | object): MeldungFilter {
    const object = typeof json === 'string' ? JSON.parse(json) : json;
    return new MeldungFilter(object);
  }
}

export enum BlvStatusId {
  UNVOLLSTAENDIG = 20,
  VOLLSTAENDIG = 80
}
